<template>
  <div id="examine">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends管理-查看</h1>
      </div>

      <div class="header-button">
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          plain
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <el-row>
      <el-col :span="15">
        <div style="background: #fff; min-height: 80vh;width: 100%;">
          <div class="bg-purple-dark">详细信息</div>
          <el-form size="mini" :inline="true" class="demo-form-inline" label-width="150px">
            <el-form-item label="GIADA Friends编号">
              <el-input v-model="memberData.gfCode" readonly></el-input>
            </el-form-item>

            <el-form-item label="CRM会员">
              <el-input v-model="memberData.custName" readonly></el-input>
            </el-form-item>

            <el-form-item label="姓名">
              <el-input
                :value="memberData.gflastName + '' + memberData.gffirstName"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-input :value="memberData.gender" readonly></el-input>
            </el-form-item>
            <el-form-item label="移动电话">
              <el-input v-model="memberData.mobile" readonly></el-input>
            </el-form-item>
            <el-form-item label="公司名称">
              <el-input v-model="memberData.companyName" readonly></el-input>
            </el-form-item>
            <el-form-item label="职位">
              <el-input v-model="memberData.position" readonly></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="memberData.gfEmail" readonly></el-input>
            </el-form-item>
          </el-form>

          <div class="bg-purple-dark">地址信息</div>
          <el-form size="mini" :inline="true" class="demo-form-inline" label-width="150px">
            <el-form-item label="省份">
              <el-input v-model="memberData.stateName" readonly></el-input>
            </el-form-item>

            <el-form-item label="城市">
              <el-input v-model="memberData.cityName" readonly></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="memberData.address" readonly></el-input>
            </el-form-item>
          </el-form>

          <div class="bg-purple-dark">积分信息</div>
          <el-form size="mini" :inline="true" class="demo-form-inline" label-width="150px">
            <el-form-item label="当前可用积分">
              <el-input
                :value="
                  memberData.currAvailPoint ? memberData.currAvailPoint : '0'
                "
                readonly
              ></el-input>
            </el-form-item>

            <el-form-item label="待取消积分">
              <el-input
                :value="
                  memberData.prevAvailPoint ? memberData.prevAvailPoint : '0'
                "
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="待生效积分">
              <el-input
                :value="
                  memberData.pendingPoints ? memberData.pendingPoints : '0'
                "
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="累积积分">
              <el-input
                :value="memberData.allPoints ? memberData.allPoints : '0'"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="已使用积分">
              <el-input
                :value="
                  memberData.exchangePoint ? memberData.exchangePoint : '0'
                "
                readonly
              ></el-input>
            </el-form-item>
          </el-form>

          <div class="bg-purple-dark">系统信息</div>

          <div style="display: flex; justify-content: space-around">
            <div style="display: flex; justify-content: space-around">
              <div>创建人</div>
              <div style="margin: 0 5px">{{ memberData.createUser }}</div>
              <div>创建日期</div>
              <div style="margin: 0 5px">
                {{ memberData.createTime | dateFormat }}
              </div>
            </div>
            <div style="display: flex; justify-content: space-around">
              <div>最后修改人</div>
              <div style="margin: 0 5px">{{ memberData.updateUser }}</div>
              <div>最后修改日期</div>
              <div style="margin: 0 5px">
                {{ memberData.updateTime | dateFormat }}
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="7">
        <div>
          
          <div style="float: right">
            <Rightcards :GFCrmID="custID"></Rightcards>
            <!-- <div>相关列表快速链接</div>
            <div class="menu" @click="examineIntegrate()">积分明细</div>
            <div class="menu" @click="examineRecommend()">推荐会员清单</div>
            <div class="menu" @click="examineSales()">陪同购买销售单</div> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getGFInfo } from "@/api/friends";
export default {
  name: "centre",
  components: {
    // Table: Table,
    // Tabs: Tabs,
  },
  data() {
    return {
      labelPosition: "left",
      memberData: {}, //会员信息
      custID:this.$route.query.custID
    };
  },
  created() {
    this.getMemberInfo(this.$route.query.custID);
  },
  methods: {//陪同购买销售单
    examineSales() {
		this.$router.push({
        path: "/ExamineSales",
        query: {
          custID: this.$route.query.custID,
        },
      });
	},
    //进入积分明细
    examineIntegrate() {
      this.$router.push({
        path: "/ExamineIntegrate",
        query: {
          custID: this.$route.query.custID,
        },
      });
    },
    //推荐会员清单
    examineRecommend() {
      this.$router.push({
        path: "/ExamineRecommend",
        query: {
          custID: this.$route.query.custID,
        },
      });
    },
    getMemberInfo(GFCrmID) {
      getGFInfo({
        GFCrmID: GFCrmID,
      }).then((res) => {
        this.memberData = res.data;
        var point=this.memberData.currAvailPoint+this.memberData.prevAvailPoint;
        this.memberData.currAvailPoint=point;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },

    // 点击返回按钮
    backHistory() {
      //   this.$router.go(-1); //返回上一层
      this.$router.push("/Administration"); //返回GF管理页面
    },
  },
};
</script>
<style lang="scss" scoped>
.menu {
  width: 150px;
  height: 40px;
  border: 1px dashed #000;
  text-align: center;
  line-height: 40px;
  margin: 5px 0;
  backface-visibility: #cdcdcd;
}

.menu:hover {
  background: #99cccc;
  border: 1px solid #000;
}

.bg-purple-dark {
  background: #f5f3e0;
  margin-bottom: 20px;
  padding: 5px;
}

#examine {
}

.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }

  .card-pagination {
    height: 50px;
  }
}

.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角
/deep/input {
  border-radius: 0 !important;
}

// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-tabs__item.is-active {
    color: #a19b5a !important;
  }

  .el-tabs__item:hover {
    color: #333;
  }

  .el-tabs__active-bar {
    height: 0;
  }

  .tabs .el-card__body {
    height: 1400px;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item__content {
    line-height: 0px;
  }
}
</style>
